export default __webpack_public_path__ + "static/home-page-hero-john-goncalves-39d9e441b84cc869e4657a201a556326.webp";